import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getMedicoAuth, updateMedico,updateDireccion,updatePerfilMedico,getPerfilMedico, getCatalogoTipoPersonal, validarCluesCatalogo, 
  getEstadoBloqueoNom,
  getCatalogoPais,  getCatalogoEntidades, getCatalogoMunicipios, getCatalogoLocalidades} from "../../../../services/usuarios"; // SIN CAMBIOS
import { validarNombreLongitud,validarNombreEspacios,validarNombreCaracteres,quitarAcentos, normalizarCURP,validarLongitudCURP,
   validarDigitoVerificador,validarCURPContraDatos,validarFechaCURP,validarSigloCURPContraFechaNacimiento,
   calcularEdadDesdeCURP,calcularEdadDesdeFechaNacimiento,
   validarEdadRango,esCurpExtranjero,generarCURP} from "../../../../utils/validaciones/identidad";
import {
   msgNombreLongitud, msgNombreEspacios, msgNombreCaracteres, msgApellidoPaternoLongitud,msgApellidoPaternoEspacios,
   msgApellidoPaternoCaracteres,msgApellidoMaternoLongitud,msgApellidoMaternoEspacios,msgApellidoMaternoCaracteres,
   msgLongitudCURP,msgDigitoVerificador,msgFechaCURP,msgEdadRango,
   msgFechaNacimientoRequerida,
  msgApellidoMaternoRequeridoCURP,
  msgPaisNacimientoRequeridoCURP,
  msgEntidadNacimientoRequeridaCURP,msgSigloCURPFechaNacimiento,
   msgCurpPos1,msgCurpPos2,msgCurpPos3,msgCurpPos4,
   msgCurpPos5,msgCurpPos6,msgCurpPos7,msgCurpPos8,msgCurpPos9,msgCurpPos10,
   msgCurpPos11,msgCurpPos12,msgCurpPos13,msgCurpPos14,msgCurpPos15,msgCurpPos16,
         } from "../../../../utils/validaciones/mensajes";
import { valoresGeoPorPais, valoresGeoPorEntidad, valoresGeoPorMunicipio, esEntidadEspecial, esMunicipioEspecial } from "../../../../utils/validaciones/catalogos";
import "./GestionPerfil.css";
import { toast } from "react-toastify";
import ConfirmarPalabraInconvenienteCURP from "../../../../utils/validaciones/ConfirmarPalabraInconvenienteCURP";

// Debe coincidir EXACTO con models.ESPECIALIDADES del backend
const ESPECIALIDADES_CHOICES = [
  "No especificado","Alergología","Anatomía Patológica","Anestesiología","Angiología",
  "Cardiología","Cirugía Cardiovascular","Cirugía General","Cirugía Maxilofacial",
  "Cirugía Pediátrica","Cirugía Plástica y Reconstructiva","Cirugía Torácica",
  "Cirugía Vascular","Coloproctología","Dermatología","Endocrinología","Gastroenterología",
  "Genética Médica","Geriatría","Ginecología y Obstetricia","Hematología","Infectología",
  "Medicina Crítica","Medicina del Deporte","Medicina Familiar","Medicina Física y Rehabilitación",
  "Medicina Interna","Medicina Legal y Forense","Medicina Nuclear",
  "Medicina Preventiva y Salud Pública","Nefrología","Neumología","Neurocirugía",
  "Neurología","Nutrición Clínica","Oftalmología","Oncología Médica","Oncología Quirúrgica",
  "Ortopedia y Traumatología","Otorrinolaringología","Otra","Pediatría","Psiquiatría",
  "Radiología","Reumatología","Toxicología","Urología",
];




const GestionPerfil = () => { 
    // ✅ Obtener el ID del doctor autenticado
  
  const navigate = useNavigate(); 
  const [perfil, setPerfil] = useState({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    sexo:"",
    sexo_biologico: "",
    correo: "",
    telefono: "",
    telefono_fijo: "",
    curpPrestador: "",
    especialidad: "",
    nombre_clinica: "",
    fecha_nacimiento: "",
    clues:"",
    programaSMyMG: "",
    tipoPersonal: null,
    paisNacimiento: null,
    entidadNacimiento: null,
    paisResidencia: null,
    entidadResidencia: null,
    municipio: null,
    localidad: null,
    escuela_licenciatura: "",
    escuela_especialidad: "",
    escuela_subespecialidad: "",
    escuela_alta_especialidad: "",
    titulo_universitario: "",
    cedula_profesional: "",
    cedula_especialidad: "",
    subespecialidad: "",
    cedula_subespecialidad: "",
    alta_especialidad: "",
    cedula_alta_especialidad: "",
    direccion: {
      calle: "",
      colonia: "",
      ciudad: "",
      estado: "",
      codigo_postal: ""
    },
    
  });

    // 🔹 Estados para expandir/cerrar secciones
    const [mostrarFormacion, setMostrarFormacion] = useState(false);
    const [usarClues, setUsarClues] = useState(false);
    const [cluesValido, setCluesValido] = useState(false);
    const [nombreEstablecimiento, setNombreEstablecimiento] = useState("");
    const [establecimientoCatalogo, setEstablecimientoCatalogo] = useState(null);
    const [listaPaises, setListaPaises] = useState([]);
    const [listaTipoPersonal, setListaTipoPersonal] = useState([]);
    const [listaEntidades, setListaEntidades] = useState([]);
    const [listaMunicipios, setListaMunicipios] = useState([]);
    const [listaLocalidades, setListaLocalidades] = useState([]);
    const [mostrarPersonal, setMostrarPersonal] = useState(true);
    const [mostrarResidencia, setMostrarResidencia] = useState(false);
    const [mostrarEstablecimiento, setMostrarEstablecimiento] = useState(false);
    const [tieneAtencionDesdeActivacionNom,setTieneAtencionDesdeActivacionNom] = useState(false);
    const [confirmarPalabraInconveniente, setConfirmarPalabraInconveniente] = useState(false);
    const [curpPalabraInconvenienteConfirmada, setCurpPalabraInconvenienteConfirmada] = useState(false);
    const curpPalabraInconvenienteConfirmadaRef = useRef(false);
    const cambioPaisNacimientoUsuarioRef = useRef(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);

  // 🔹 Cargar datos del médico al iniciar
  useEffect(() => {
    const cargarPerfil = async () => {
      try {
        const [medico, perfilExtendido, estadoBloqueoNom, tiposPersonal] = await Promise.all([
          getMedicoAuth(),
          getPerfilMedico(),
          getEstadoBloqueoNom(),
          getCatalogoTipoPersonal()
        ]);

        setListaTipoPersonal(
        [...(tiposPersonal || [])]
          .filter((tipo) => [2, 4].includes(Number(tipo.CATALOG_KEY)))
          .sort((a, b) => Number(a.CATALOG_KEY) - Number(b.CATALOG_KEY))
      );


    setTieneAtencionDesdeActivacionNom(
        Boolean(estadoBloqueoNom?.tiene_atencion_desde_activacion_nom)
      );
  
       const tipoPersonalPrelleno = medico?.tipoPersonal ?? null;
  
       setPerfil((prev) => ({
          ...prev,
          ...medico,
          ...perfilExtendido,
          tipoPersonal: tipoPersonalPrelleno,
          programaSMyMG: medico?.programaSMyMG === null || medico?.programaSMyMG === undefined ? "" : Number(medico.programaSMyMG),
          fecha_nacimiento: medico?.fecha_nacimiento || "",
          paisNacimiento: medico?.paisNacimiento ? String(medico.paisNacimiento) : null,
          entidadNacimiento: medico?.entidadNacimiento ? String(medico.entidadNacimiento).padStart(2, '0') : null,
          paisResidencia: medico?.paisResidencia ? String(medico.paisResidencia) : null,
          entidadResidencia: medico?.entidadResidencia ? String(medico.entidadResidencia).padStart(2, '0') : null,
          municipio: medico?.municipio ? String(medico.municipio).padStart(3, '0') : null,
          localidad: medico?.localidad ? String(medico.localidad).padStart(4, '0') : null,
          direccion: medico.direccion || {
            calle: "", colonia: "", ciudad: "", estado: "", codigo_postal: ""
          }
        }));

        // 🔹 Sincronizar estado del switch CLUES al cargar perfil
      if (perfilExtendido?.clues) {
        setUsarClues(true);
        validarClues(perfilExtendido.clues, false)
      } else {
        setUsarClues(false);
        setCluesValido(false);
        setNombreEstablecimiento("");
        setEstablecimientoCatalogo(null);
        setPerfil(prev => ({ ...prev, programaSMyMG: 0 }));
      }
      // Traer opcion de paises
     const cargarPaises = async () => {
        const paises = await getCatalogoPais();
        const ordenados = paises.sort(
          (a, b) => (a.DESCRIPCION || "").trim().localeCompare((b.DESCRIPCION || "").trim(), 'es')
        );
        setListaPaises(ordenados);
      };

      cargarPaises();
            // Cargar entidades siempre (32 registros, necesarios para el dropdown)
      const entidades = await getCatalogoEntidades();
      setListaEntidades(entidades);

      // Si ya tiene entidad, cargar municipios
      if (medico?.entidadResidencia) {
        const entidadPad = String(medico.entidadResidencia).padStart(2, '0');
        const municipios = await getCatalogoMunicipios(entidadPad);
        setListaMunicipios(municipios.sort((a, b) => (a.MUNICIPIO || "").trim().localeCompare((b.MUNICIPIO || "").trim(), 'es')));

        // Si también tiene municipio, cargar localidades
        if (medico?.municipio) {
          const municipioPad = String(medico.municipio).padStart(3, '0');
          const localidades = await getCatalogoLocalidades(entidadPad, municipioPad);
          setListaLocalidades(localidades.sort((a, b) => (a.LOCALIDAD || "").trim().localeCompare((b.LOCALIDAD || "").trim(), 'es')));
        }
      }
      } catch (error) {
        console.error("❌ Error obteniendo datos completos del perfil:", error);
      }
    };
  
    cargarPerfil();
  }, []);

  useEffect(() => {
    // Solo reaccionar cuando el usuario cambió el país a mano,
    // no cuando se precarga el perfil desde el backend.
    if (!cambioPaisNacimientoUsuarioRef.current) return;
    cambioPaisNacimientoUsuarioRef.current = false;
    if (!perfil.paisNacimiento || Number(perfil.paisNacimiento) === 142) {
          setPerfil((prev) => ({
            ...prev,
            entidadNacimiento: null,
          }));
          return;
        }

  const geo = valoresGeoPorPais(perfil.paisNacimiento);
  setPerfil((prev) => ({
    ...prev,
    entidadNacimiento: geo.entidad,
  }));
}, [perfil.paisNacimiento]);
  


  // 🔹 Manejo de cambios en los inputs
  const handleInputChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;            // <-- usar let, no const

    if (name === "curpPrestador") {
    curpPalabraInconvenienteConfirmadaRef.current = false;
    setCurpPalabraInconvenienteConfirmada(false);  
      value = normalizarCURP(value);
      if (value === "XXXX999999XXXXXX99" && String(perfil.paisNacimiento) === "142") {
        setPerfil((prev) => ({ ...prev, curpPrestador: value, paisNacimiento: null, entidadNacimiento: null, sexo: calcularSexoDesdeCURP(value, prev.sexo) }));
        return;
      }
      setPerfil((prev) => ({ ...prev, curpPrestador: value, sexo: calcularSexoDesdeCURP(value, prev.sexo) }));
      return;
    }

    if (name.startsWith("direccion.")) {
      const campoDireccion = name.split(".")[1];
      setPerfil((prev) => ({
        ...prev,
        direccion: { ...(prev.direccion || {}), [campoDireccion]: value }
      }));
    } else {
      setPerfil((prev) => ({ ...prev, [name]: value }));
      if (name === "clues") {
        validarClues(value);
      }
    }
  };
  // 🔹 Guardar cambios en `db.json`
// 🔹 Guardar cambios en el perfil y la dirección
  const handleSave = async () => {
    if (loadingSubmit) return;
     const nombre = quitarAcentos((perfil.nombre || "").trim());
const apellidoPaterno = quitarAcentos((perfil.apellido_paterno || "").trim());
const apellidoMaterno = quitarAcentos((perfil.apellido_materno || "").trim());

if (!validarNombreLongitud(nombre)) {
  msgNombreLongitud();
  return;
}

if (!validarNombreEspacios(nombre)) {
  msgNombreEspacios();
  return;
}

if (!validarNombreCaracteres(nombre)) {
  msgNombreCaracteres();
  return;
}

if (!validarNombreLongitud(apellidoPaterno)) {
  msgApellidoPaternoLongitud();
  return;
}

if (!validarNombreEspacios(apellidoPaterno)) {
  msgApellidoPaternoEspacios();
  return;
}

if (!validarNombreCaracteres(apellidoPaterno)) {
  msgApellidoPaternoCaracteres();
  return;
}

if (!validarNombreLongitud(apellidoMaterno)) {
  msgApellidoMaternoLongitud();
  return;
}

if (!validarNombreEspacios(apellidoMaterno)) {
  msgApellidoMaternoEspacios();
  return;
}

if (!validarNombreCaracteres(apellidoMaterno)) {
  msgApellidoMaternoCaracteres();
  return;
}  

    try {
      
      const curp = normalizarCURP(perfil.curpPrestador || "");

     if (curp) {
      if (!validarLongitudCURP(curp)) {
        msgLongitudCURP();
        return;
      }

      if (!validarDigitoVerificador(curp)) {
       msgDigitoVerificador();
       return;
     }

      if (!esCurpExtranjero(curp)) {

        const resultadoCURP = validarCURPContraDatos(
          curp,
          nombre,
          apellidoPaterno,  
          apellidoMaterno,
          perfil.fecha_nacimiento,
          perfil.sexo,
          perfil.entidadNacimiento,
          listaEntidades,
          perfil.paisNacimiento
        );

      
      if (!resultadoCURP.valida) {
        const msgsPorPosicion = {
          1: msgCurpPos1, 2: msgCurpPos2, 3: msgCurpPos3, 4: msgCurpPos4,
          5: msgCurpPos5, 6: msgCurpPos6, 7: msgCurpPos7, 8: msgCurpPos8,
          9: msgCurpPos9, 10: msgCurpPos10, 11: msgCurpPos11, 12: msgCurpPos12,
        13: msgCurpPos13, 14: msgCurpPos14, 15: msgCurpPos15, 16: msgCurpPos16
        };

      resultadoCURP.errores.forEach(err => {
        if (err.posicion === 0) {
        if (err.motivo === "fecha_requerida") msgFechaNacimientoRequerida();
        if (err.motivo === "apellido_materno_requerido") msgApellidoMaternoRequeridoCURP();
        if (err.motivo === "pais_nacimiento_requerido") msgPaisNacimientoRequeridoCURP();
        if (err.motivo === "entidad_nacimiento_requerida") msgEntidadNacimientoRequeridaCURP();
        return;
      }

      const msgFn = msgsPorPosicion[err.posicion];
      if (msgFn) msgFn();
    });
        return;
      }

      if (!validarFechaCURP(curp)) {
        msgFechaCURP();
        return;
      }
      
      if (!validarSigloCURPContraFechaNacimiento(curp, perfil.fecha_nacimiento)) {
        msgSigloCURPFechaNacimiento();
        return;
      }

      const edad = calcularEdadDesdeCURP(curp);

      if (!validarEdadRango(edad)) {
        msgEdadRango();
        return;
      }


      if (
      resultadoCURP.requiereConfirmacionPalabraInconveniente &&
      !curpPalabraInconvenienteConfirmadaRef.current
    ) {
      setConfirmarPalabraInconveniente(true);
      return;
    }

  } else if (perfil.fecha_nacimiento) {
    const edad = calcularEdadDesdeFechaNacimiento(perfil.fecha_nacimiento);

    if (!validarEdadRango(edad)) {
      msgEdadRango();
      return;
    }
  }
} else if (perfil.fecha_nacimiento) {
  const edad = calcularEdadDesdeFechaNacimiento(perfil.fecha_nacimiento);

  if (!validarEdadRango(edad)) {
    msgEdadRango();
    return;
  }
}

// ✅ Candado CLUES: si el switch está ON, debe ser válido sí o sí
      if (usarClues && !cluesValido) {
        alert("Debe ingresar un CLUES válido o apagar el switch.");
        return;
      }

      if (!perfil.fecha_nacimiento) {
        perfil.fecha_nacimiento = null;
      }

     if (puedeUsarProgramaSMyMG && perfil.programaSMyMG === "") {
  toast.error("Debe seleccionar si el prestador está contratado bajo el Programa SMyMG.");
  return;
      }

      if (
        Number(perfil.tipoPersonal) === 4 &&
        !perfil.especialidad
      ) {
        toast.error("Seleccione una especialidad o deje el tipo de personal como médico general.");
        return;
      }

      const perfilSeguro = {
        ...perfil,
        nombre,
        apellido_paterno: apellidoPaterno,
        apellido_materno: apellidoMaterno,
        programaSMyMG: puedeUsarProgramaSMyMG ? Number(perfil.programaSMyMG) : 0
      };
      
      setLoadingSubmit(true);

      // ✅ PASA id y el objeto perfil seguro
      const actualizado = await updateMedico(perfilSeguro);
      const direccionActualizada = await updateDireccion(perfilSeguro.direccion);
      const perfilActualizado = await updatePerfilMedico(perfilSeguro);

      if (actualizado || direccionActualizada || perfilActualizado) {
        alert("✅ Cambios guardados exitosamente.");
        navigate("/dashboard/configuracion");
      } else {
        alert("⚠️ Hubo un problema guardando los cambios.");

      }
    } catch (error) {
      console.error("❌ Error al guardar perfil:", error);
      alert(`❌ Error: ${error.response?.data?.detail || "Error inesperado"}`);

    }
    setLoadingSubmit(false);
  };

  // Cascada residencia
  const handlePaisResidencia = (valor) => {
    const geo = valoresGeoPorPais(valor);

    setPerfil((prev) => ({
      ...prev,
      paisResidencia: valor,
      entidadResidencia: geo.entidad,
      municipio: geo.municipio,
      localidad: geo.localidad,
    }));
    setListaMunicipios([]);
    setListaLocalidades([]);
  };

  const handleEntidadResidencia = async (valor) => {
    const geo = valoresGeoPorEntidad(valor);

    setPerfil((prev) => ({
      ...prev,
      entidadResidencia: valor || null,
      municipio: geo.municipio,
      localidad: geo.localidad,
    }));
    setListaLocalidades([]);

    // Solo cargar municipios del catálogo si es entidad normal (no especial)
    if (valor && !esEntidadEspecial(valor)) {
      const municipios = await getCatalogoMunicipios(valor);
      setListaMunicipios(municipios.sort((a, b) => (a.MUNICIPIO || "").trim().localeCompare((b.MUNICIPIO || "").trim(), 'es')));;
    } else {
      setListaMunicipios([]);
    }
  };

  const handleMunicipio = async (valor) => {
    const geo = valoresGeoPorMunicipio(valor);

    setPerfil((prev) => ({
      ...prev,
      municipio: valor || null,
      localidad: geo.localidad,
    }));
    setListaLocalidades([]);

    // Solo cargar localidades del catálogo si es municipio normal (no especial)
    if (valor && !esMunicipioEspecial(valor) && perfil.entidadResidencia) {
      const localidades = await getCatalogoLocalidades(perfil.entidadResidencia, valor);
      setListaLocalidades(localidades.sort((a, b) => (a.LOCALIDAD || "").trim().localeCompare((b.LOCALIDAD || "").trim(), 'es')));
    }
  };

  const validarClues = async (valor, resetearProgramaSiAplica = true) => {
  const cluesNormalizado = String(valor || "").trim();

  if (!cluesNormalizado) {
    setCluesValido(false);
    setNombreEstablecimiento("");
    setEstablecimientoCatalogo(null);
    setPerfil(prev => ({ ...prev, programaSMyMG: 0 }));
    return;
  }

  const data = await validarCluesCatalogo(cluesNormalizado);

  const cluesCoincide =
    data &&
    String(data.clues || "").trim().toUpperCase() === cluesNormalizado.toUpperCase();

  if (cluesCoincide) {
  setCluesValido(true);
  setNombreEstablecimiento(data.nombre_unidad);
  setEstablecimientoCatalogo(data);

  const institucion = String(data.institucion || "").trim().toUpperCase();

  if (["SSA", "IMB"].includes(institucion)) {
    if (resetearProgramaSiAplica) {
      setPerfil(prev => ({ ...prev, programaSMyMG: "" }));
    }
  } else {
    setPerfil(prev => ({ ...prev, programaSMyMG: 0 }));
  }
} else {
  setCluesValido(false);
  setNombreEstablecimiento("");
  setEstablecimientoCatalogo(null);
  setPerfil(prev => ({ ...prev, programaSMyMG: 0 }));
}
};

const [ultimaCurp, setUltimaCurp] = useState("");

  useEffect(() => {

    try {
      const curpGenerada = generarCURP(
        perfil?.nombre || "X",
        perfil?.apellido_paterno || "X",
        perfil?.apellido_materno || "X",
        perfil?.fecha_nacimiento || "0000-00-00",
        perfil?.sexo || "X",
        perfil?.entidadNacimiento || "NE",
        listaEntidades || []
      );

      // 🚫 evitar repetir logs
      if (curpGenerada !== ultimaCurp) {
       
        setUltimaCurp(curpGenerada);
      }

    } catch (error) {
      console.error("❌ ERROR GENERANDO CURP:", error);
    }

  }, [
    perfil.nombre,
    perfil.apellido_paterno,
    perfil.apellido_materno,
    perfil.fecha_nacimiento,
    perfil.sexo,
    perfil.entidadNacimiento,
    listaEntidades,
    ultimaCurp
  ]);


  // 🔹 Validación onBlur del campo CURP
  const handleBlurCURP = () => {
    

    const curp = normalizarCURP(perfil.curpPrestador || "");
    if (!curp) return;

    if (!validarLongitudCURP(curp)) {
      msgLongitudCURP();
      return;
    }

    if (!validarDigitoVerificador(curp)) {
       msgDigitoVerificador();
       return;
     }

    if (esCurpExtranjero(curp)) return;

    if (!validarFechaCURP(curp)) {
      msgFechaCURP();
      return;
    }

    
    if (!validarSigloCURPContraFechaNacimiento(curp, perfil.fecha_nacimiento)) {
      msgSigloCURPFechaNacimiento();
      return;
    }

    const edad = calcularEdadDesdeCURP(curp);
    if (!validarEdadRango(edad)) {
      msgEdadRango();
      return;
    }
    
    const nombre = quitarAcentos((perfil.nombre || "").trim());
    const apellidoPaterno = quitarAcentos((perfil.apellido_paterno || "").trim());
    const apellidoMaterno = quitarAcentos((perfil.apellido_materno || "").trim());

    const resultadoCURP = validarCURPContraDatos(
      curp,
      nombre,
      apellidoPaterno,
      apellidoMaterno,
      perfil.fecha_nacimiento,
      perfil.sexo,
      perfil.entidadNacimiento,
      listaEntidades,
      perfil.paisNacimiento
    );

    if (!resultadoCURP.valida) {
      const msgsPorPosicion = {
        1: msgCurpPos1, 2: msgCurpPos2, 3: msgCurpPos3, 4: msgCurpPos4,
        5: msgCurpPos5, 6: msgCurpPos6, 7: msgCurpPos7, 8: msgCurpPos8,
        9: msgCurpPos9, 10: msgCurpPos10, 11: msgCurpPos11, 12: msgCurpPos12,
        13: msgCurpPos13, 14: msgCurpPos14, 15: msgCurpPos15, 16: msgCurpPos16
      };
     resultadoCURP.errores.forEach(err => {
        if (err.posicion === 0) {
          if (err.motivo === "fecha_requerida") msgFechaNacimientoRequerida();
          if (err.motivo === "apellido_materno_requerido") msgApellidoMaternoRequeridoCURP();
          if (err.motivo === "pais_nacimiento_requerido") msgPaisNacimientoRequeridoCURP();
          if (err.motivo === "entidad_nacimiento_requerida") msgEntidadNacimientoRequeridaCURP();
          return;
        }

        const msgFn = msgsPorPosicion[err.posicion];
        if (msgFn) msgFn();
      });
    }
  };

    const institucionClues = String(
    establecimientoCatalogo?.institucion || ""
  ).trim().toUpperCase();

  const puedeUsarProgramaSMyMG =
    Boolean(perfil.nom024) &&
    usarClues &&
    cluesValido &&
    ["SSA", "IMB"].includes(institucionClues);

    const perfilBloqueado = Boolean(perfil.nom024) && tieneAtencionDesdeActivacionNom;

  const calcularSexoDesdeCURP = (curp, sexoManual = "") => {
  const curpNorm = normalizarCURP(curp || "");
  if (!curpNorm || curpNorm.length !== 18 || esCurpExtranjero(curpNorm)) {
    return sexoManual;
  }
  const c = curpNorm.charAt(10);
  if (c === "H") return "Hombre";
  if (c === "M") return "Mujer";
  if (c === "X") return "No binario";
  return sexoManual;
};

  return (
    <div className="gestion-perfil-layout">
      <h2>Gestión de Perfil</h2>
       <p>Los campos marcados con * son obligatorios.</p>
       {/* ===== SECCIÓN 1 — DATOS PERSONALES + NACIMIENTO ===== */}
       
      <div className="rubro">
        <h3 onClick={() => setMostrarPersonal(!mostrarPersonal)}>
          Datos Personales {mostrarPersonal ? "▼" : "▶"}
        </h3>
        {mostrarPersonal && (
          <>
            <div className="form-group">
              <label>Nombre*:</label>
              <input type="text" name="nombre" value={perfil.nombre} onChange={handleInputChange}  disabled={perfilBloqueado} onBlur={(e) => {
               const v = quitarAcentos(e.target.value.trim());
                setPerfil(prev => ({ ...prev, nombre: v }));
                if (!validarNombreLongitud(v)) {
                  msgNombreLongitud();
                  setPerfil(prev => ({ ...prev, nombre: "" }));
                  } else if (!validarNombreEspacios(v)) {
                  msgNombreEspacios();
                  setPerfil(prev => ({ ...prev, nombre: "" }));
                  } else if (!validarNombreCaracteres(v)) {
                    msgNombreCaracteres();
                    setPerfil(prev => ({ ...prev, nombre: "" }));
                  }
              }}/>
               
            </div>
            <div className="form-group">
              <label>Apellido Paterno*:</label>
              <input type="text" name="apellido_paterno" value={perfil.apellido_paterno} onChange={handleInputChange}  disabled={perfilBloqueado}
                onBlur={(e) => {
                  const v = quitarAcentos(e.target.value.trim());
                  setPerfil(prev => ({ ...prev, apellido_paterno: v }));
                  if (!validarNombreLongitud(v)) {
                    msgApellidoPaternoLongitud();
                    setPerfil(prev => ({ ...prev, apellido_paterno: "" }));
                  } else if (!validarNombreEspacios(v)) {
                    msgApellidoPaternoEspacios();
                    setPerfil(prev => ({ ...prev, apellido_paterno: "" }));
                  } else if (!validarNombreCaracteres(v)) {
                    msgApellidoPaternoCaracteres();
                    setPerfil(prev => ({ ...prev, apellido_paterno: "" }));
                  }
                }}
              />
            </div>
            <div className="form-group">
             <label>Apellido Materno*:</label>
             <input type="text" name="apellido_materno" value={perfil.apellido_materno} onChange={handleInputChange}  disabled={perfilBloqueado}
                onBlur={(e) => {
                  const v = quitarAcentos(e.target.value.trim());
                  setPerfil(prev => ({ ...prev, apellido_materno: v }));
                  if (!validarNombreLongitud(v)) {
                    msgApellidoMaternoLongitud();
                    setPerfil(prev => ({ ...prev, apellido_materno: "" }));
                  } else if (!validarNombreEspacios(v)) {
                    msgApellidoMaternoEspacios();
                    setPerfil(prev => ({ ...prev, apellido_materno: "" }));
                  } else if (!validarNombreCaracteres(v)) {
                    msgApellidoMaternoCaracteres();
                    setPerfil(prev => ({ ...prev, apellido_materno: "" }));
                  }
                }}
              />
            </div>
            <div className="form-group">
            <label>Sexo biológico*:</label>
            <select
              name="sexo_biologico"
              value={perfil.sexo_biologico || ""}
              onChange={handleInputChange}
              disabled={perfilBloqueado}
            >
              <option value="" disabled>Selecciona una opción</option>
               <option value="M">Hombre</option>
                <option value="F">Mujer</option>
                <option value="O">Intersexual</option>
            </select>
          </div>
            <div className="form-group">
              <label>Fecha de nacimiento*:</label>
              <input 
                type="date" 
                name="fecha_nacimiento" 
                value={perfil.fecha_nacimiento} 
                onChange={handleInputChange} 
                 disabled={perfilBloqueado}
              />
            </div>
            <div className="form-group">
              <label>Teléfono Celular:</label>
              <input type="text" name="telefono" value={perfil.telefono} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label>Teléfono Fijo:</label>
              <input type="text" name="telefono_fijo" value={perfil.telefono_fijo} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label>País de nacimiento*:</label>
              <select
                name="paisNacimiento"
                value={perfil.paisNacimiento ?? ""}
                 disabled={perfilBloqueado}
              onChange={(e) => {
                  cambioPaisNacimientoUsuarioRef.current = true;
                  setPerfil((prev) => ({
                    ...prev,
                    paisNacimiento: e.target.value ? Number(e.target.value) : null,
                  }));
                }}
              >
                <option value="" disabled>Selecciona un país</option>
                {listaPaises
                  .filter((pais) => !["247", "248"].includes(String(pais.CATALOG_KEY)))
                  .map((pais) => (
                  <option
                    key={pais.CATALOG_KEY}
                    value={pais.CATALOG_KEY}
                    disabled={String(pais.CATALOG_KEY) === "142" && perfil.curpPrestador === "XXXX999999XXXXXX99"}
                  >
                    {pais.DESCRIPCION}
                  </option>
                ))}
              </select>
            </div>
            {String(perfil.paisNacimiento) === "142" && (
              <div className="form-group">
                <label>Entidad de nacimiento*:</label>
                <select
                  value={perfil.entidadNacimiento ?? ""}
                   disabled={perfilBloqueado}
                  onChange={(e) => setPerfil(prev => ({ 
                    ...prev, 
                    entidadNacimiento: e.target.value || null
                  }))}
                >
                  <option value="" disabled>Selecciona una entidad</option>
                  {listaEntidades.filter((e) => !["00", "88", "99"].includes(String(e.CATALOG_KEY))).map((e) => (
                    <option key={e.CATALOG_KEY} value={e.CATALOG_KEY}>
                      {e.ENTIDAD_FEDERATIVA}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label>CURP del médico*:</label>
              <input 
                type="text" 
                name="curpPrestador" 
                maxLength={18}                      // <--- esto
                value={perfil.curpPrestador} 
                 disabled={perfilBloqueado}
                onChange={handleInputChange} 
                onBlur={handleBlurCURP}
              />

              </div>
            <div className="form-group">
              <label>Sexo registrado ante RENAPO*:</label>
              <select name="sexo" value={perfil.sexo} disabled={
                      perfilBloqueado ||
                      (!!normalizarCURP(perfil.curpPrestador || "") &&
                      normalizarCURP(perfil.curpPrestador || "").length === 18 &&
                      !esCurpExtranjero(normalizarCURP(perfil.curpPrestador || "")))
                    }  onChange={handleInputChange}> 
                <option value="" disabled>Selecciona una opción</option>
                <option value="Hombre">Hombre</option>
                <option value="Mujer">Mujer</option>
                <option value="No binario">No binario</option>
              </select>

            </div>
             </>
        )}
      </div>
            {/* ===== SECCIÓN 2 — RESIDENCIA ===== */}
            
      <div className="rubro">
       <h3 onClick={() => setMostrarResidencia(!mostrarResidencia)}>
          Residencia {mostrarResidencia ? "▼" : "▶"}
        </h3>
        {mostrarResidencia && (
          <>
            {/* NOM-024 */}
            <div className="form-group">
              <label>País de residencia*:</label>
              <select
                value={perfil.paisResidencia ?? ""}
                //disabled={perfilBloqueado}
                onChange={(e) => handlePaisResidencia(e.target.value || null)}
              >
                <option value="" disabled>Selecciona un país</option>
                {listaPaises
                  .filter((pais) => !["247", "248"].includes(String(pais.CATALOG_KEY)))
                  .map((pais) => (
                  <option key={pais.CATALOG_KEY} value={pais.CATALOG_KEY}>
                    {pais.DESCRIPCION}
                  </option>
                ))}
              </select>
            </div>

            {String(perfil.paisResidencia) === "142" && (
              <div className="form-group">
                <label>Entidad de residencia*:</label>
                <select
                  value={perfil.entidadResidencia ?? ""}
                  //disabled={perfilBloqueado}
                  onChange={(e) => handleEntidadResidencia(e.target.value ? e.target.value : null)}
                >
                  <option value="" disabled>Selecciona una entidad</option>
                {listaEntidades.filter((e) => !["00", "88", "99"].includes(String(e.CATALOG_KEY))).map((e) => (
                    <option key={e.CATALOG_KEY} value={e.CATALOG_KEY}>
                      {e.ENTIDAD_FEDERATIVA}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {String(perfil.paisResidencia) === "142" && perfil.entidadResidencia && !esEntidadEspecial(perfil.entidadResidencia) && (
              <div className="form-group">
                <label>Municipio*:</label>
                <select
                  value={perfil.municipio ?? ""}
                  //disabled={perfilBloqueado}
                  onChange={(e) => handleMunicipio(e.target.value || null)}
                >
                  <option value="" disabled>Selecciona un municipio</option> 
                  
                  {listaMunicipios.map((m) => (
                    <option key={m.CATALOG_KEY} value={m.CATALOG_KEY}>
                      {m.MUNICIPIO} - {m.CATALOG_KEY}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {String(perfil.paisResidencia) === "142" && perfil.municipio && !esMunicipioEspecial(perfil.municipio) && (
              <div className="form-group">
                <label>Localidad*:</label>
                <select
                  value={perfil.localidad ?? ""}
                  //disabled={perfilBloqueado}
                  onChange={(e) => setPerfil(prev => ({ ...prev, localidad: e.target.value || null }))}
                >
                  <option value="" disabled>Selecciona una localidad</option> 
                  
                  {listaLocalidades.map((l) => (
                    <option key={l.CATALOG_KEY} value={l.CATALOG_KEY}>
                        {l.LOCALIDAD} - {l.CATALOG_KEY}
                    </option>
                  ))}
                </select>
              </div>
            )}
             

            {/* Dirección para recetas */}
            <h4>Dirección para recetas</h4>
             
            <div className="form-group">
              <label>Nombre del establecimiento:</label>
              <input type="text" name="nombre_clinica" value={perfil.nombre_clinica} onChange={handleInputChange} />
            </div>
             
                        <div className="form-group">
              <label>Dirección</label>
              <div className="direccion-grid">
                <div>
                  <label>Calle:</label>
                  <input 
                    type="text" 
                    name="direccion.calle" 
                    value={perfil.direccion.calle} 
                    onChange={handleInputChange} 
                  />
                </div>

                <div>
                  <label>Colonia:</label>
                  <input 
                    type="text" 
                    name="direccion.colonia" 
                    value={perfil.direccion.colonia} 
                    onChange={handleInputChange} 
                  />
                </div>

                <div>
                  <label>Ciudad:</label>
                  <input 
                    type="text" 
                    name="direccion.ciudad" 
                    value={perfil.direccion.ciudad} 
                    onChange={handleInputChange} 
                  />
                </div>

                <div>
                  <label>Estado:</label>
                  <input 
                    type="text" 
                    name="direccion.estado" 
                    value={perfil.direccion.estado} 
                    onChange={handleInputChange} 
                  />
                </div>

                <div>
                  <label>Código Postal:</label>
                  <input 
                    type="text" 
                    name="direccion.codigo_postal" 
                    value={perfil.direccion.codigo_postal} 
                    onChange={handleInputChange} 
                  />
                </div>
              </div>
            </div>
      </>
      )}
    </div>
      {/* ===== SECCIÓN 3 — ESTABLECIMIENTO ===== */}
      {perfil.nom024 && (
           <div className="rubro">
        <h3 onClick={() => setMostrarEstablecimiento(!mostrarEstablecimiento)}>
          Establecimiento {mostrarEstablecimiento ? "▼" : "▶"}
        </h3>
        {mostrarEstablecimiento && (
          <>
            <div className="form-group">
            <label>¿Mi establecimiento cuenta con CLUES?*</label>
            <span className="switch-texto-opcion">No / Sí</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={usarClues}
                 disabled={perfilBloqueado}
                onChange={(e) => {
                  setUsarClues(e.target.checked);
                  if (!e.target.checked) {
                    setPerfil(prev => ({
                      ...prev,
                      clues: "",
                      programaSMyMG: 0
                    }));
                    setCluesValido(false);
                    setNombreEstablecimiento("");
                    setEstablecimientoCatalogo(null);
                  }
                }}
              />
              <span className="slider" />
            </label>
          </div>

          {usarClues && (
            <div className="form-group">
              <label>CLUES*:</label>
              <input
                type="text"
                name="clues"
                maxLength={11}
                value={perfil.clues || ""}
                 disabled={perfilBloqueado}
                onChange={handleInputChange}
              />

              {cluesValido && (
                <small style={{ color: "green" }}>
                  Establecimiento: {nombreEstablecimiento}
                </small>
              )}

              {!cluesValido && perfil.clues?.length === 11 && (
                <small style={{ color: "red" }}>
                  CLUES no se encuentra en catálogo o no está en operación.
                </small>
              )}
            </div>
          )}

          {puedeUsarProgramaSMyMG && (
            <div className="form-group">
              <label> ¿El prestador de servicios está contratado
                 bajo el Programa de Servicios Médicos y Medicamentos Gratuitos? (SMyMG)*</label>
             

              <select 
                name="programaSMyMG"
                value={perfil.programaSMyMG ?? ""}
                 disabled={perfilBloqueado}
                onChange={(e) => {
                  setPerfil(prev => ({
                    ...prev,
                    programaSMyMG: e.target.value === "" ? "" : Number(e.target.value)
                  }));
                }}
              >
                <option value="">Seleccione</option>
                <option value={0}>0 - No</option>
                <option value={1}>1 - Sí</option>
              </select>

              
            </div>
          )}

          {perfil.nom024 && usarClues && cluesValido && !puedeUsarProgramaSMyMG && (
            <small style={{ color: "#6b7280", display: "block", marginTop: "6px" }}>
              Para esta institución, el Programa SMyMG no aplica; se registrará automáticamente como 0 - No.
            </small>
          )}
            {/* <div className="form-group">
              <label>Tipo de Perfil:</label>
              <select name="tipoPerfil" value={perfil.tipoPerfil} onChange={handleInputChange}>
                <option value="Médico">Médico</option>
                <option value="Asistente">Asistente</option>
              </select>
            </div>*/}
          </>
        )}
      </div>
        )}
      {/* ===== SECCIÓN 4 — TIPO DE PERSONAL Y FORMACIÓN ===== */}
      <div className="rubro">
        <h3 onClick={() => setMostrarFormacion(!mostrarFormacion)}>
          Tipo de Personal y Formación {mostrarFormacion ? "▼" : "▶"}
        </h3>
        {mostrarFormacion && (
          <>
            {/* Tipo de personal */}
            <div className="form-group">
              <label>Tipo de personal*:</label>
              <select
                value={perfil.tipoPersonal ?? ""}

                disabled={perfilBloqueado}

                  onChange={(e) => {
                    const nuevoTipoPersonal = e.target.value ? Number(e.target.value) : null;

                    setPerfil(prev => ({
                      ...prev,
                      tipoPersonal: nuevoTipoPersonal,
                      especialidad:
                        nuevoTipoPersonal === 2
                          ? "No especificado"
                          : prev.especialidad === "No especificado"
                            ? ""
                            : prev.especialidad
                    }));
                  }}
              >
                
                <option value="" disabled>
                  Selecciona un tipo de personal
                </option>

                {listaTipoPersonal.map((tipo) => (
                  <option
                    key={tipo.CATALOG_KEY}
                    value={tipo.CATALOG_KEY}
                  >
                    {tipo.TIPO_PERSONAL}
                  </option>
                ))}
              </select>
            </div>

            {/* 📌 Licenciatura — visible si hay tipoPersonal */}
            {perfil.tipoPersonal && (
              <div className="subrubro">
                <h4>Licenciatura</h4>
                <div className="form-group">
                  <label>Título:</label>
                  <input type="text" name="titulo_universitario" value={perfil.titulo_universitario} onChange={handleInputChange} />
                </div>
                <div className="form-group">
                  <label>Cédula Profesional*:</label>
                  <input type="text" name="cedula_profesional" value={perfil.cedula_profesional} onChange={handleInputChange} disabled={perfilBloqueado} />
                </div>
                <div className="form-group">
                  <label>Escuela:</label>
                  <input type="text" name="escuela_licenciatura" value={perfil.escuela_licenciatura} onChange={handleInputChange} />
                </div>
              </div>
            )}

            {/* 📌 Especialidad y Subespecialidad — solo si es especialista */}
            {Number(perfil.tipoPersonal) === 4 && (
              <>
                <div className="subrubro">
                  <h4>Especialidad</h4>
                  <div className="form-group">
                    <label>Título:</label>
                    <select
                      name="especialidad"
                      value={perfil.especialidad || ""}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Selecciona una especialidad</option>
                     {ESPECIALIDADES_CHOICES
                      .filter(opt => opt !== "No especificado")
                      .map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Cédula de Especialidad*:</label>
                    <input type="text" name="cedula_especialidad" value={perfil.cedula_especialidad} onChange={handleInputChange} disabled={perfilBloqueado}/>
                  </div>
                  <div className="form-group">
                    <label>Escuela:</label>
                    <input type="text" name="escuela_especialidad" value={perfil.escuela_especialidad} onChange={handleInputChange} />
                  </div>
                </div>

                <div className="subrubro">
                  <h4>Subespecialidad y Alta Especialidad</h4>
                  <div className="form-group">
                    <label>Subespecialidad:</label>
                    <input type="text" name="subespecialidad" value={perfil.subespecialidad} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Cédula de Subespecialidad:</label>
                    <input type="text" name="cedula_subespecialidad" value={perfil.cedula_subespecialidad} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Escuela:</label>
                    <input type="text" name="escuela_subespecialidad" value={perfil.escuela_subespecialidad} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Alta Especialidad:</label>
                    <input type="text" name="alta_especialidad" value={perfil.alta_especialidad} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Cédula de Alta Especialidad:</label>
                    <input type="text" name="cedula_alta_especialidad" value={perfil.cedula_alta_especialidad} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Escuela:</label>
                    <input type="text" name="escuela_alta_especialidad" value={perfil.escuela_alta_especialidad} onChange={handleInputChange} />
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
      <button type="button" onClick={handleSave} disabled={loadingSubmit}>
  {loadingSubmit ? "Guardando…" : "Guardar Cambios"}
</button>
      <ConfirmarPalabraInconvenienteCURP
        visible={confirmarPalabraInconveniente}
        onConfirm={() => {
          curpPalabraInconvenienteConfirmadaRef.current = true;
          setCurpPalabraInconvenienteConfirmada(true);
          setConfirmarPalabraInconveniente(false);

          setTimeout(() => {
            handleSave();
          }, 0);
        }}
        onCancel={() => {
          curpPalabraInconvenienteConfirmadaRef.current = false;
          setConfirmarPalabraInconveniente(false);
          setCurpPalabraInconvenienteConfirmada(false);
        }}
      />
    </div>
  );
  
};

export default GestionPerfil;
